// extracted by extract-css-chunks-webpack-plugin
module.exports = {"sizeChart_table":"SizeChart__sizeChart_table","sizeChart_table_body__grouped":"SizeChart__sizeChart_table_body__grouped","sizeChart_info":"SizeChart__sizeChart_info"};